import factoryStore from '../components/factory-store'

const projectWish = {
  ...factoryStore('ProjectWish'),
}

const projectWishStore = {
  ...projectWish,
}

export default projectWishStore
